import { uniqueId } from 'lodash';
import { WithId } from 'types/common/WithId';

export const addId: <Data>(data: Data) => WithId<Data> = (data) => ({
    id: uniqueId(),
    ...data,
});
